import { AnalysisBase, AnalysisTypeType } from '@models/Analysis';
import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';
import { useCallback } from 'react';

const getBaseApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/analysisBase`;
};

type AnalysisItem = {
  analysisType?: { id?: string; name?: string } | null;
  analysisStatus?: string | null;
};

export type ParsedAnalysis = {
  analysisTypeName: string;
  ok: boolean | null;
};


export type AnalysisBaseStatus ={
  name: AnalysisTypeType['name'];
  status: AnalysisBase['analysisStatus']
}

// export type SeriesAnalysisMap = AnalysisBaseStatus[];
export type SeriesAnalysisStatusMap = Record<string,AnalysisBaseStatus[]>;

export function getDefaultItem(items:AnalysisBaseStatus[]){
  return items.find((item) => item.name.toLowerCase() === 'default')
}
export function statusToBool(status: unknown): boolean | null {
  if (status === "Succeeded") return true;
  if (status === "Failed") return false;
  return null;
}

export function parseAnalysisTypeAndStatusBool(input: unknown): ParsedAnalysis[] {
  const arr: unknown = Array.isArray(input) ? input : (input as any)?.data;
  if (!Array.isArray(arr)) return [];

  return (arr as AnalysisItem[])
    .map((item) => ({
      analysisTypeName: item?.analysisType?.name ?? null,
      ok: statusToBool(item?.analysisStatus),
    }))
    .filter((x): x is ParsedAnalysis => {
      // name이 없거나 "default"면 제외
      if (!x.analysisTypeName) return false;
      return x.analysisTypeName.toLowerCase() !== "default";
    });
}

export async function fetch_base_info(
  accessToken: string,
  seriesid: string,
): Promise<AnalysisBaseStatus[]> {
  const url = await getBaseApi();
  let result :AnalysisBaseStatus[] = [];
  try {
    const res: AxiosResponse = await axios({
      method: 'get',
      url: url,
      params: {
        filters: JSON.stringify({ series: seriesid }),
        limit: 200,
      },
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const items = res.data['data'] as AnalysisBase[];

    //console.log(items)
    items.forEach((item: AnalysisBase) => {
      const {name} = item.analysisType;
      const {analysisStatus:status} = item;
      result.push({name,status});
    })
    const summary = items
    .map((item: AnalysisBase) => {
        item.analysisType.name
        const name = item?.analysisType?.name ?? 'unknown';
        const status = item?.analysisStatus ?? 'unknown';
        return `${name}: ${status}`;
      })
      .join(', ');
    console.log(summary);
    // return res.data['data'];
  } catch (err) {
    console.log(err);
    // return [];
  }
  return result;
}



export function getAnalysisStatusByName(items: AnalysisBaseStatus[]){
 return new Map(
  items.reduce<[string, boolean | null][]>((acc, item) => {
    const key = item.name.toLowerCase();
    const status = statusToBool(item.status);

    if (key === 'modify-lumen' ||key === 'modify-regulator' ) {
      const index = acc.findIndex(([k]) => k === key);

      if (index >= 0) {
        // 둘 다 true일 때만 true, 아니면 pending(null)
        acc[index][1] = acc[index][1] === true && status === true ? true : null;
      } else {
        acc.push([key, status]);
      }
    } else {
      acc.push([key, status]);
    }

    return acc;
  }, []),
);
};

export function isSegmentationSucceeded(items: AnalysisBaseStatus[]){
  const statusByName = getAnalysisStatusByName(items);
  return statusByName.get('segmentation') === true;
};

// 이거는 직접 만들었지만 사용하진않음
export async function send_base_info(accessToken: string, seriesid: string) {
  const url = await getBaseApi();
  const res: AxiosResponse = await axios({
    method: 'get',
    url: url,
    params: {
      filters: JSON.stringify({ series: seriesid }),
    },
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
  })
    .then((res) => {
      const parsed = parseAnalysisTypeAndStatusBool(res.data['data']);
      console.log(res.data['data'])
      console.log(parsed);
      return parsed;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  if (res.status == 201) {
    console.log(res);
    return true;
  }
  return false;
}
